import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  CircularProgress,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useSnackbarAlert } from "../../hooks/useSnackbarAlert";
import { sendEmailVerification } from "firebase/auth";
import { auth } from "../../firebase"; // use centralized auth instance

const EmailConfirmationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const snackbar = useSnackbarAlert();

  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email");

  const [loading, setLoading] = useState(false);
  const [resendSuccess, setResendSuccess] = useState(false);

  const handleResend = async () => {
    const user = auth.currentUser;
    if (user && !user.emailVerified) {
      try {
        setLoading(true);
        await sendEmailVerification(user);
        snackbar.success("Verification email sent.");
        setResendSuccess(true);
      } catch (err) {
        console.error("Resend failed:", err);
        if (err.code === "auth/too-many-requests") {
          snackbar.error(
            "You’ve requested too many emails. Please try again later."
          );
        } else {
          snackbar.error("Failed to resend email. Please try again.");
        }
      } finally {
        setLoading(false);
      }
    } else {
      snackbar.error("User not logged in or already verified.");
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 10, textAlign: "center" }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Verify Your Email
      </Typography>
      <Typography variant="body1" sx={{ mb: 4 }}>
        We’ve sent a verification email to{" "}
        <strong>{email || "your address"}</strong>. Please check your inbox and
        click the link to activate your account.
      </Typography>

      <Button
        variant="outlined"
        onClick={handleResend}
        disabled={loading || resendSuccess}>
        {loading ? (
          <CircularProgress size={20} />
        ) : resendSuccess ? (
          "Sent"
        ) : (
          "Resend Email"
        )}
      </Button>

      <Box sx={{ mt: 4 }}>
        <Typography variant="body2" color="text.secondary">
          Didn’t get the email? Check your spam folder or try resending.
        </Typography>
      </Box>
    </Container>
  );
};

export default EmailConfirmationPage;
